import { Box, Text, Flex, ListItem, UnorderedList } from "@chakra-ui/react";
import moment from "moment";

const renderTooltip = (props: any, user: any) => {
  const { label, payload = [] } = props;

  const custom_currency =
    user?.user?.company?.company_configurations[0]?.custom_currency?.currency ||
    "$";

  return (
    <Box bg="white" p="10px" borderWidth="1px" borderColor="gray.200">
      <Text fontSize="14px" fontWeight="600">
        {moment(label, "MMM YY").format("MMMM YYYY")}
      </Text>
      <UnorderedList listStyleType="none" m="0" p="0">
        {payload.map((entry: any, index: number) => (
          <ListItem key={`item-${index}`} my="10px" mr="0">
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center">
                <Box
                  bg={entry.color}
                  width="14px"
                  height="14px"
                  borderRadius="4px"
                  mr="8px"
                ></Box>
                <Text color="#171B1E" fontWeight="500" fontSize="14px">
                  {entry.name} {custom_currency}
                  {entry.value}M
                </Text>
              </Flex>
            </Flex>
          </ListItem>
        ))}
      </UnorderedList>
    </Box>
  );
};

export default renderTooltip;
